<div class="div-mapping">
    <div class="mapping-label">
        <label>Mapping Config</label>
    </div>

    <div class="mapping-body">
        <div class="mapping-title">
            <span class="mapping-input">Tamale Contact metadata</span> <span class="mapping-input right-label">Exchange
                Contact
                metadata</span>
        </div>

        <div class="label-section">
            <div class="mapping-section" *ngFor="let item of config;let j=index;trackBy:trackByFn">
                <div class="mapping-line" *ngFor="let value of item.container index as i;trackBy:trackByFn">
                    <div>
                        <input *ngIf="!value.tamaleEditable" class="tam-input mapping-input"
                            [(ngModel)]="value.tamaleName" [disabled]="!value.tamaleEditable" />
                        <kendo-dropdownlist *ngIf="value.tamaleEditable" [popupSettings]="{appendTo: 'component'}"
                            #dropDownEl [data]="item.TDataSource" [(ngModel)]="value.tamaleName" style="height: 27px;"
                            class="mapping-input mapping-dropdownlist" (valueChange)="valueChangeT($event,item)"
                            (focus)="dropDownEl.toggle(true)" (mousedown)="$event.preventDefault()">
                        </kendo-dropdownlist>
                    </div>

                    <smart-icon name="link" class="link-icon"></smart-icon>
                    <div>
                        <input *ngIf="!value.exchangeEditable" class="tam-input mapping-input"
                            [(ngModel)]="value.exchangeName" [disabled]="!value.exchangeEditable" />
                        <kendo-dropdownlist *ngIf="value.exchangeEditable" [popupSettings]="{appendTo: 'component'}"
                            #dropDownEl [data]="item.EDataSource" [(ngModel)]="value.exchangeName"
                            class="mapping-input mapping-dropdownlist" (valueChange)="valueChangeE(value,item,j)"
                            (focus)="dropDownEl.toggle(true)" (mousedown)="$event.preventDefault()">
                        </kendo-dropdownlist>
                    </div>
                    <!-- <input class="tam-input mapping-input" [(ngModel)]="value.exchangeName"
                        [disabled]="!value.exchangeEditable" /> -->
                    <smart-icon *ngIf="value.deletable" class="close-icon" name="close"
                        (click)="deleteControl(item,i,value.tamaleName,value.exchangeName)">
                    </smart-icon>
                </div>
                <label class="mapping-tag " (click)="addControl(item)">{{item.addTag}}</label>
            </div>
        </div>
    </div>
    <div class="mapping-control-button">
        <div><button tam-button tamType="secondary" tamSize="normal" class="dialog-button"
                (click)="clickResetToDefault()">Reset to
                default</button>
        </div>
        <div>
            <button tam-button tamType="tertiary" tamSize="normal" class="dialog-button mapping-cancel"
                (click)="clickClose()">
                Close</button>
            <button tam-button tamType="primary" tamSize="normal" class="dialog-button mapping-save"
                [tamLoading]="isSaving" (click)="clickSave()">Save</button>
        </div>
    </div>

</div>